import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, makeStyles, TextField } from '@material-ui/core';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import MissionVehicleTable from './MissionVehicleTable';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import LoadingTexteBackdrop from "../../tools/LoadingTexteBackdrop";
import { useNavigate } from 'react-router';
import Spacer from '../../../components/Spacer';
import DownloadIcon from '@mui/icons-material/Download';
import { Autocomplete, Button } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SearchIcon from '@mui/icons-material/Search';
import MissionTransportService from '../../../services/MissionTransportService';
import Message from '../../tools/Message';
import VehicleService from '../../../services/VehicleService';
import { exportToExcelJS } from '../../../helpers/ExcelJsHelper_old';
import DetailsMissionDialog from './DetailsMissionDialog';
import ConfirmationTransportByRow from './ConfirmationTransportByRow';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "2%",
    height: "60%",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
  },
}));

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const buildMissionFilterData = (sourceFilter) => ({
  destination: sourceFilter.destination,
  debut: sourceFilter.debut,
  fin: sourceFilter.fin,
  status: sourceFilter.status !== 'ALL' ? sourceFilter.status : null,
  title: sourceFilter.title,
  vehicle: sourceFilter.vehicle,
  reference: sourceFilter.reference,
  kilometrage_state:
    sourceFilter.kilometrage_state !== 'ALL'
      ? sourceFilter.kilometrage_state
      : null,
});

const buildMissionRowId = (row) => [
  Number(row.is_request) || 0,
  Number(row.mission_planning_id) || 0,
  Number(row.mission_planning_agenda_id) || 0,
  Number(row.mission_planning_destination_id) || 0,
].join('-');
const MissionVehicleList = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const now = new Date();
  const firstDayCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0); 
  const thirdMonth = new Date(now.getFullYear(), now.getMonth() + 3, 1);
  const lastDayThirdMonth = new Date(thirdMonth.getFullYear(), thirdMonth.getMonth() + 1, 0);
  const [rows, setRows] = useState([])
  const [columns, setColumns] = useState([]);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedMissions, setSelectedMissions] = useState([]);
  const [confirmation, setConfirmation] = useState(false);
  const [openDialogAssignment, setOpenDialogAssignment] = useState({
    open: false,
    isEdit: false,
  });
  const [reference, setReference] = useState([]);
  const referenceFilterKeyRef = useRef(null);
  const [vehicles, setVehicles] = useState([]);
  const [filter, setFilter] = useState({ // pour le filtre des missions
    destination: '',
    debut: formatDate(firstDayCurrentMonth), // Format YYYY-MM-DD
    fin: formatDate(lastDayThirdMonth), // Format YYYY-MM-DD
    status: 'ALL',
    title: '',
    vehicle: null,
    reference: '',
    kilometrage_state: 'ALL',
  });
  const [appliedFilter, setAppliedFilter] = useState({ ...filter });
   const [warnDialog, setWarnDialog] = useState({
          open: false,
          message: "",
      });
 
  const [confirmationTitle, setConfirmationTitle] = useState('');
  const [rowToConfirm, setRowToConfirm] = useState(null) // pour la confirmation de la gestion du transport
  const [activateTransport, setActivateTransport] = useState({ // pour la reactivation de la gestion du transport
    open: false,
    mission_timesheet_id: 0,
    mission_planning_agenda_id: 0,
    mission_id: 0,
  });
   const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const [detailsDialog, setDetailsDialog] = useState({
    open: false,
    missionData: {},
  });
  const kilometrageStateOptions = [{label : 'Tous', value: 'ALL'} ,{ label: 'Oui (en attente de validation)', value: 'PENDING' }, { label: 'Non', value: 'EMPTY' }, { label: 'Validée', value: "CONFIRMED"}, { label: 'Refusée', value: "REFUSED" } ]
  const StatusOptions = [{label: 'Tous', value: 'ALL'}, { label: 'En attente', value: 'false' }, { label: 'Confirmée', value: 'true' }, { label: 'Sollicitation', value: "Solicitation"} ];

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const loadMissions = useCallback(async (
    filtersToApply,
    options = {}
  ) => {
    const { forceReferences = false } = options;
    const filterData = buildMissionFilterData(filtersToApply);
    const filterKey = JSON.stringify(filterData);
    const includeReferences =
      forceReferences || referenceFilterKeyRef.current !== filterKey;

    setOpenLoadingSimpleBackdrop(true);

    try {
      const result = await MissionTransportService.filterPlanningValidated(
        filterData,
        false,
        includeReferences
      );

      if (!result || !Array.isArray(result.data)) {
        return false;
      }

      if (Array.isArray(result.references)) {
        setReference(result.references);
        referenceFilterKeyRef.current = filterKey;
      }

      const filteredRows = result.data.map((row) => ({
        ...row,
        id: buildMissionRowId(row),
      }));

      setRows(filteredRows);

      return true;
    } catch (error) {
      console.error(
        'Erreur lors du chargement des missions de transport :',
        error
      );
      return false;
    } finally {
      setOpenLoadingSimpleBackdrop(false);
    }
  }, []);
  useEffect(() => {
    loadMissions(appliedFilter);
  }, [appliedFilter, loadMissions]);

  useEffect(() => {
    VehicleService.getAllVehicles().then((result) => {
      if (result && result.data) {
        setVehicles(result.data);
      }
    });
  }, []);

  const handleFilter = () => {
    setSelectedMissions([]);
    setSelectAll(false);
    setAppliedFilter({ ...filter });
  };

  const refreshMissions = useCallback(() => (
    loadMissions(
      appliedFilter,
      { forceReferences: true }
    )
  ), [appliedFilter, loadMissions]);
  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    selectAll ? setSelectAll(false) : setSelectAll(true);
    if (isChecked) {
      const allMissionsId = rows.map(mission => mission.mission_planning_id);
      setSelectedMissions(rows);
    } else {
      setSelectedMissions([]);
    }
  };


  const handleExportMissionToExcel = async () => {
    setOpenLoadingSimpleBackdrop(true);

    try {
      const result = await MissionTransportService.filterPlanningValidated(
        buildMissionFilterData(appliedFilter),
        true,
        false
      );

      if (!result || !Array.isArray(result.data)) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: `L'export des missions a échoué.`,
        });
        return;
      }

      const fileName =
        `missions_transport_${new Date().toLocaleDateString()}.xlsx`;
      const columnsToExport = columns
        .map((column) => ({
          headerName: column.headerName,
          field: column.field,
          width: column.width,
        }))
        .filter((column) => ![
          'action',
          'id',
          'id_2',
          'confirmation',
          'kilometrages',
        ].includes(column.field));

      const rowsToExport = result.data.map((row) => ({
        reference: row.reference,
        mission_title: row.mission_title,
        lieu: row.lieu,
        users: Array.isArray(row.users)
          ? row.users.map((user) => user.nom).join(', ')
          : '',
        date_begin: new Date(row.date_begin).toLocaleDateString(),
        date_end: new Date(row.date_end).toLocaleDateString(),
        vehicle: Array.isArray(row.vehicles)
          ? row.vehicles
            .map((vehicle) => (
              `${vehicle.vhc_imm} (${vehicle.vhc_type})`
            ))
            .join(', ')
          : '',
        transport_management:
          row.transport_management === 'true'
            ? 'Confirmée'
            : (Number(row.is_request) === 1
              ? 'Sollicitation'
              : 'En attente'),
        status: row.status === 'true' ? 'Confirmée' : 'En attente',
      }));

      exportToExcelJS(rowsToExport, columnsToExport, fileName);
    } finally {
      setOpenLoadingSimpleBackdrop(false);
    }
  };
  const handleAssign = () => {
    if (selectedMissions.length === 0) {
      setConfirmationTitle('Assigner une(des) voiture(s)')
      setConfirmation(true);
      return;
    }

    setOpenDialogAssignment({ open: true, isEdit: false });

  }

  const handleShowEditDialog = (missionData) => {
    setSelectedMissions([missionData]);
    setOpenDialogAssignment({ open: true, isEdit: true });
  };

  const handleCloseDialog = () => {
    setSelectedMissions([]);
    setSelectAll(false);
    setOpenDialogAssignment({ open: false, isEdit: false });
    refreshMissions(); // Rafraîchit les données après la fermeture du dialogue
    setRowToConfirm(null); // Réinitialise la ligne à confirmer
  }

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  }

  const handleActivateTimesheet = () => {
    setOpenLoadingSimpleBackdrop(true);
    TimeSheetMissionService.activateTimesheet(activateTransport.mission_timesheet_id, 'PENDING').then((result) => {
      if (result && result.status) {
        setMessage({ open: true, color: 'green', messageInfo: 'Modification de la timesheet réactivée.' });
        setOpenLoadingSimpleBackdrop(false);
        setRows(rows.map((row) => {
          if (row.mission_planning_id === activateTransport.mission_id) {
            row.mission_timesheet_state = 'PENDING';
          }
          return row;
        }
        ));
        setActivateTransport({ open: false, mission_timesheet_id: 0, mission_planning_agenda_id: 0, mission_id: 0 });
        refreshMissions(); // Rafraîchit les données après la réactivation
      }
    });
  };

  const handleRowClick = (params, event) => {
  const ignoredFields = ['id', 'id_2', 'action', 'confirmation', 'kilometrages']; // Liste des champs à ignorer
 
  const clickedField = event?.target?.closest('[data-field]')?.getAttribute('data-field'); // Vérifie si le clic provient d'une cellule d'une colonne à ignorer

  if (ignoredFields.includes(clickedField)) {
    return; 
  }

  setDetailsDialog({
    open: true,
    missionData: params.row,
  });
};


  return (
    <MainContainer {...headerDataImmo}>
      <LoadingTexteBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />

        <Grid container spacing={4} justifyContent={"flex-end"} >
          <Grid item xs={12} sm={6} md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {/* <Button variant="contained"
            className={classes.btn} size='small'
            onClick={handleAssign} startIcon={<DirectionsCarIcon />}>
            Assigner une(des) voiture(s)
          </Button> */}
          <Spacer x={1} />
          <Button
            variant="contained" size='small'
            onClick={handleExportMissionToExcel}
            className={classes.btn}
            style={{ backgroundColor: 'darkgreen', color: 'white' }}
            startIcon={<DownloadIcon />}
          >
            EXPORT EXCEL
          </Button>
          <Spacer x={1} />
          <Button
            variant="contained"
            color="primary" size='small'
            onClick={handleFilter}
            className={classes.btn}
          >
            <SearchIcon style={{ marginRight: '8px' }} />
            Filtrer
          </Button>
          </Grid>
        </Grid>

      <Grid container xs={12} spacing={2} marginTop={2} >
      <Grid item xs={12} sm={6} md={3}>
          
          <label className={classes.labelPosition}>Référence:</label>
        <FormControl fullWidth variant="outlined" size="small">
              <Autocomplete
                            id="tags-outlined"
                            options={reference}
                            sx={{
                              '& .MuiInputBase-root': { height: 40 }, 
                              '& .MuiInputBase-input': { padding: '4px 8px' } 
                            }}
                            getOptionLabel={(option) =>
                              `${option}`
                            }
                            filterSelectedOptions
                            onChange={(event, newValue) => {
                              setFilter({ ...filter, reference: newValue });
                            }
                            }
                            size='small'
                            value={filter.reference}
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" size="small" />
                            )}
                          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
          Objet de la mission :
          <TextField
            fullWidth
            id="title"
            size="small"
            variant="outlined"
            value={filter.title}
            name="title"
          onChange={handleChangeFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Destination :
          <TextField
            fullWidth
            id="destination"
            size="small"
            variant="outlined"
            value={filter.destination}
            name="destination"
          onChange={handleChangeFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Voiture :
          <Autocomplete
                            id="tags-outlined"
                            options={vehicles || []}
                            sx={{
                              '& .MuiInputBase-root': { height: 40 }, 
                              '& .MuiInputBase-input': { padding: '4px 8px' } 
                            }}
                            getOptionLabel={(option) =>
                              `${option?.vhc_imm} (${option?.vhc_type})` || ''
                            }
                          
                            onChange={(event, newValue) => {
                              setFilter({ ...filter, vehicle: newValue });
                            }
                            }
                            size='small'
                            value={filter.vehicle}
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" size="small" />
                            )}
                          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Date de début:
          <TextField
            fullWidth
            id="date_debut"
            size="small"
            variant="outlined"
            type="date"
            value={filter.debut}
            name="debut"
          onChange={handleChangeFilter}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          Date de fin:
          <TextField
            fullWidth
            id="date_fin"
            size="small"
            variant="outlined"
            type="date"
            value={filter.fin}
            name="fin"
          onChange={handleChangeFilter}
          />
        </Grid>
        {/* <Grid item xs={12} sm={6} md={3}>
          Statut transport:
          <Autocomplete
                            id="tags-outlined"
                            options={StatusOptions || []}
                            sx={{
                              '& .MuiInputBase-root': { height: 40 }, 
                              '& .MuiInputBase-input': { padding: '4px 8px' } 
                            }}
                            getOptionLabel={(option) =>
                              `${option.label}`
                            }
                            filterSelectedOptions
                            onChange={(event, newValue) => {
                              setFilter({ ...filter, status: newValue.value });
                            }
                            }
                            size='small'
                            value={filter.status ? StatusOptions.find(option => option.value === filter.status) : null}
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" size="small" />
                            )}
                          />
        </Grid> */}
        <Grid item xs={12} sm={6} md={3}>
          Statut Timesheet:
          <Autocomplete
                            id="tags-outlined"
                            options={kilometrageStateOptions || []}
                            sx={{
                              '& .MuiInputBase-root': { height: 40 }, 
                              '& .MuiInputBase-input': { padding: '4px 8px' } 
                            }}
                            getOptionLabel={(option) =>
                              `${option.label}`
                            }
                            filterSelectedOptions
                            onChange={(event, newValue) => {
                              setFilter({ ...filter, kilometrage_state: newValue.value });
                            }
                            }
                            size='small'
                            value={filter.kilometrage_state ? kilometrageStateOptions.find(option => option.value === filter.kilometrage_state) : null}
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" size="small" />
                            )}
                          />
        </Grid>
      </Grid>
       <MissionVehicleTable
        rows={rows}
        loading={openLoadingSimpleBackdrop}
        handleSelectAllChange={handleSelectAllChange}
        selectedMissions={selectedMissions}
        setSelectedMissions={setSelectedMissions}
        setOpenDialogAssignment={setOpenDialogAssignment}
        handleRowClick={handleRowClick}
        setActivateTransport={setActivateTransport}
        handleShowEditDialog={handleShowEditDialog}
        selectAll={selectAll}
        setColumns={setColumns}
        setRowToConfirm={setRowToConfirm}
       />

      <Dialog
        open={confirmation}
        onClose={() => setConfirmation(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
          {confirmationTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              "Veuillez selectionner au moins une mission pour continuer."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" component="span" onClick={() => setConfirmation(false)}>
            Fermer
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={activateTransport.open}
        onClose={() => setActivateTransport({ open: false, mission_timesheet_id: 0 })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
          {"Réactiver la modification de la timesheet"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              "Êtes-vous sûr de vouloir réactiver la modification de la timesheet ? Cela permettra de modifier à nouveau les informations relatives au transport de cette mission."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" component="span" onClick={() => {
            setActivateTransport({
              open: false,
              mission_timesheet_id: 0,
              mission_planning_agenda_id: 0,
              mission_id: 0,
            })
            }}>
            Annuler
          </Button>
          <Button disabled={openLoadingSimpleBackdrop} variant="contained" color="primary" component="span" onClick={() => handleActivateTimesheet()}>
          {  openLoadingSimpleBackdrop ? "Chargement…" : "Confirmer"}
          </Button>
        </DialogActions>
      </Dialog>
<DetailsMissionDialog open={detailsDialog.open} onClose={() => setDetailsDialog({ open: false, missionData: {} })} missionData={detailsDialog.missionData} />

          <Dialog
                        open={warnDialog.open}
                        onClose={() => setWarnDialog({ ...warnDialog, open: false })}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                              Confirmation impossible
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                La confirmation ne peut pas être effectuée, car les kilométrages de la mission ne sont pas encore saisis ou validés.
                                Veuillez envoyer une demande de saisie et valider les kilométrages avant de confirmer la mission.
                                </DialogContentText>
                                </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setWarnDialog({ ...warnDialog, open: false })
                                } color="error" autoFocus variant='contained'>
                                Fermer
                                </Button>
                            </DialogActions>
                    </Dialog>
        
        <ConfirmationTransportByRow rowToConfirm={rowToConfirm} setRowToConfirm={setRowToConfirm} closeDialog={handleCloseDialog} setRows={setRows}/>
    </MainContainer>
  );
};

export default MissionVehicleList;


